import { Config } from '../domain/entities/Config';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/ProductService';
import { query, serviceQueries } from '@estee/elc-service-bus';
import { EarlyAccessAPI, IEarlyAccessInfo }  from '~api/EarlyAccessAPI';

export class ConfigRepository {
    private config: Config;
    private earlyAccessAPI: EarlyAccessAPI;

    constructor() {
        this.config = diContainer.get(serviceNames.config);
        this.earlyAccessAPI = diContainer.get(serviceNames.earlyAccessApi);
    }

    public getConfigs = async (configs: string[]) => {
        const config = await query(serviceQueries.GET_CONFIG, configs);
        const { enableLoyaltyEarlyAccessDynamicCTA } = config;
        if (enableLoyaltyEarlyAccessDynamicCTA) {
            config.earlyAccessInfo = await this.getEarlyAccessConfig() as IEarlyAccessInfo;
            config.earlyAccessLoaded = true;
        }
        this.config.updateConfig(config);
    };

    public getEarlyAccessConfig = async () => {
       return await this.earlyAccessAPI.getEarlyAccessInfo();
    }
}
